/**
 * PageTablet JS controller.
 *
 * Events and actions done when on tablet template.
 */

const $ = jQuery;

/**
 * Class PageTablet
 */
export default class PageTablet {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.$body = $( 'body' );
        this.modalContent = $( '.component-cards__description__content a' );

    }

    /**
     * Closes the currently opened modal.
     * @return {void}
     */
    closeModal() {

        const $modal = $( document.getElementById( 'js-tablet-modal' ) );

        // Return early if no open modal found.
        if ( ! $modal ) {
            return;
        }

        // Remove class from modal to hide content
        $modal.removeClass( 'modal--is-open' );

        // Change aria state
        $modal.attr( 'aria-hidden', 'true' );

        // Remove class from body to enable scrolling.
        $( 'body' ).removeClass( 'modal-open-on-page' );
    }

    /**
     * All common events.
     */
    events() {
        // When form is submitted, wait 6 seconds and reload the page.
        jQuery(document).bind( 'gform_confirmation_loaded', function() {
            setTimeout(function() {
                window.location.reload();
            }, 7000);
        });

        // 60000  = 1 minute
        // 120000 = 2 minutes
        // 180000 = 3 minutes
        let timerID = null;
        let timeoutDuration = 120000; // Put the timeout duration here

        // Clear form fields after 1 minute of inactivity
        window.addEventListener( 'keydown', function( e ) {
            if( timerID !== null ) {
                clearTimeout( timerID );
                timerID = null;
            }

            timerID = setTimeout( function()  {
                $( '.tablet-form' )[0].reset();
            }, timeoutDuration );
        }, false );

        // Open modal
        this.modalContent.on( 'click', function( e ) {
            const $modal = $( document.getElementById( 'js-tablet-modal' ) );

            // Add class to modal to reveal content
            $modal.addClass( 'modal--is-open' );

            // Add class to site body to prevent background-scrolling.
            $( 'body' ).addClass( 'modal-open-on-page' );

            // Change aria state
            $modal.attr( 'aria-hidden', 'false' );

            e.preventDefault();
        });

    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.events();

    }

}
